import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { BookingPageOptions } from '../../components/booking_page_options'

export const BookingPageOptionsPanel = ({ isLocked, ...props }) => (
  <AccordionPanel
    titleId="event-link-id"
    title={I18n.t('publisher.event_type_editor.sections.booking_page_options.title')}
    subheader={<Summary />}
    {...props}
  >
    <BookingPageOptions isLocked={isLocked} />
  </AccordionPanel>
)
